import React from "react";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IMAGES } from "../../../assets/images/images";
import { Formik, Field, ErrorMessage, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { forgotPasswordOTP } from "../../../utility/apiServices/userServices";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
// Validation schema

const PropertyOwnerForgotPassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required(t("login.email_required")),
  });
  const initialValues = { email: "" };
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await forgotPasswordOTP({ email: values.email });
      if (response?.status) {
        navigate("/resetpassword", {
          state: { email: values.email },
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response?.message || t("error_message"),
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error?.message || t("error_message"),
      });
      console.error("Form submission error: ", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <Formik
                initialValues={initialValues}
                validationSchema={ForgotPasswordSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <FormikForm>
                    <h1>{t("title")}</h1>
                    <p className="para">{t("description")}</p>


                    <div className="mb-3">
                    <label htmlFor="email">{t("email_label")}</label>
                      <Field
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder={t("email_placeholder")}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="errorStyle"
                      />
                    </div>

                    <Button
                      type="submit"
                      className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3 w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? t("sending") : t("continue")}
                    </Button>

                    <p className="text-center">
                      {t("back_to")}{" "}
                      <Link
                        to="/login"
                        className="forgotPassword forgotPassword1"
                      >
                        {t("header.login")}
                      </Link>
                    </p>
                  </FormikForm>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyOwnerForgotPassword;
